export default __webpack_public_path__ + "static/media/11.88600c93.png";